import { OnInit, Component, OnDestroy } from "@angular/core";
import { WizardStep } from "../../../wizard/wizard.component";
import { MedicalServiceWizardService } from "../../../services/wizard/medical-service/medical-service-wizard";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { MatTableDataSource, MatDialog } from "@angular/material";
import { FormGroup, FormBuilder } from "@angular/forms";
import { MedicalAppointmentCareUpdate } from "../../../model/medical-appointment-care-update";
import { FilterCompleteService } from "src/app/filter-complete/filter-complete";
import { PhysicianFilter } from "src/app/model/physician-Filter";
import {
  DialogTextEditComponent,
  DialogTextEditResponse,
} from "../../dialogs/dialog-text-edit/dialog-text-edit.component";
import { PreviusStudiesDigitizedService } from "../../../services/previous-studies-digitized/previous-studies-digitized.service";
import { PreviousStudiesDigitizedShowDialogComponent } from "../../dialogs/previous-studies-digitized-show-dialog/previous-studies-digitized-show-dialog.component";
import {
  MobileScannAction,
  MobileScannService,
} from "../../../services/hub-services/mobile-scann/mobile-scann.service";
import { StatusPhotography } from "../../../model/status-photography";
import { MedicalRecordIntegrationService } from "src/app/services/medical-record-integration/medical-record-integration.service";

@Component({
  selector: "medical-service-care-component",
  templateUrl: "./medical-service-care.component.html",
  styleUrls: ["./medical-service-care.component.css"],
})
export class MedicalServiceCareComponent
  implements OnInit, OnDestroy, WizardStep
{
  loading: boolean;
  uploading = false;
  completed: boolean;
  isInit: boolean;
  protocol: string;
  patientFullName: string;
  equipmentName: string;
  diagnostic: string;
  patientAge: number;
  medicalServiceCareForm: FormGroup;
  tabIndex = 0;
  hideElement = true;
  validMedicalOrderState: boolean;
  validMedicalOrderAmount: boolean;
  statusPhotographies: StatusPhotography[] = [];
  medicalAppointmentId: number;

  hasAditional: boolean;
  hasSetSupplie: boolean;
  dataSourcePrincipal = new MatTableDataSource([]);
  dataSourceAditional = new MatTableDataSource([]);
  dataSourceSetSupplie = new MatTableDataSource([]);
  displayColumnsPrincipal = [
    "PracticeRegionName",
    "Quantity",
    "AccessionNumber",
  ];
  displayColumnsAditional = ["PracticeRegionAditionalName"];
  displayColumnsSetSupplie = ["SetSupplieName"];

  constructor(
    private medicalServiceWizardService: MedicalServiceWizardService,
    private psdService: PreviusStudiesDigitizedService,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private medicalRecordIntegrationService: MedicalRecordIntegrationService,
    private mobileScannService: MobileScannService,
    private notificationToastService: NotificationToastService
  ) {
    this.medicalServiceCareForm = this.formBuilder.group({
      MedicalAppointmentId: [""],
      MedicalAppointmentProcedureIds: [""],
      CommentaryPreStudy: [""],
      ClinicaDataRecord: [""],
      PlatesDelivery: [false],
      CdDelivery: [false],
      PlatesAmount: [""],
      PreviousStudies: [false],
      IsInternation: [false],
      IsEndAttention: [false],
      PreviousStudiesAmount: [""],
      PreviousStudiesDetails: [""],
      ProcedureState: [""],
      StatusPhotography: [""],
    });
  }

  activate(): void {}

  save(): void {
    this.medicalServiceWizardService.setMedicalAppointmentCareUpdate(
      <MedicalAppointmentCareUpdate>this.medicalServiceCareForm.getRawValue()
    );
    this.completed = true;
  }

  openClinicaDataRecordEdit() {
    const info = <MedicalAppointmentCareUpdate>(
      this.medicalServiceCareForm.getRawValue()
    );
    const dialogRef = this.dialog.open(DialogTextEditComponent, {
      width: "50%",
      data: {
        text: info.ClinicaDataRecord,
        textMenu: "Datos clínicos y Antecedentes",
      },
    });

    dialogRef.afterClosed().subscribe((result: DialogTextEditResponse) => {
      if (result) {
        this.medicalServiceCareForm.patchValue({
          ClinicaDataRecord: result.text,
        });
      }
    });
  }

  get valid(): boolean {
    return this.completed;
  }

  async medicalRecordPublish() {
    try {
      const info = <MedicalAppointmentCareUpdate>(
        this.medicalServiceCareForm.getRawValue()
      );

      const url = await this.medicalRecordIntegrationService.open(
        info.MedicalAppointmentId,
        true
      );

      window.open(url, "_blank");
    } catch (err) {
      this.notificationToastService.error(
        err.error.ExceptionMessage,
        "Atención paciente"
      );
    }
  }

  openCommentaryPreStudyEdit() {
    const info = <MedicalAppointmentCareUpdate>(
      this.medicalServiceCareForm.getRawValue()
    );
    const dialogRef = this.dialog.open(DialogTextEditComponent, {
      width: "50%",
      data: {
        text: info.CommentaryPreStudy,
        textMenu: "Comentarios y Preinforme",
      },
    });

    dialogRef.afterClosed().subscribe((result: DialogTextEditResponse) => {
      if (result) {
        this.medicalServiceCareForm.patchValue({
          CommentaryPreStudy: result.text,
        });
      }
    });
  }

  async ngOnInit() {
    try {
      this.loading = true;

      this.statusPhotographies =
        await this.medicalServiceWizardService.getStatusPhotography();
      const info =
        await this.medicalServiceWizardService.getMedicalAppointmentCareEditInfo();
      this.protocol =
        this.medicalServiceWizardService.medicalServiceSearchItem.Protocol;
      this.diagnostic = info.Diagnostic;
      this.patientFullName =
        this.medicalServiceWizardService.medicalServiceSearchItem.PatientFullName;
      this.equipmentName =
        this.medicalServiceWizardService.medicalServiceSearchItem.EquipmentName;
      this.patientAge = info.PatientAge;
      this.validMedicalOrderState = info.ValidMedicalOrderState;
      this.validMedicalOrderAmount = info.ValidMedicalOrderAmount;

      this.mobileScannService.subscribe({
        action: MobileScannAction.scannStudy,
        params: info.MedicalAppointmentId.toString(),
      });

      this.dataSourcePrincipal = new MatTableDataSource(
        info.MedicalAppointmentProcedurePrincipals
      );
      this.dataSourceAditional = new MatTableDataSource(
        info.MedicalAppointmentProcedureAditionals
      );
      this.dataSourceSetSupplie = new MatTableDataSource(
        info.MedicalAppointmentProcedureSetSupplies
      );

      this.hasAditional = info.MedicalAppointmentProcedureAditionals
        ? info.MedicalAppointmentProcedureAditionals.length > 0
        : false;

      this.hasSetSupplie = info.MedicalAppointmentProcedureSetSupplies
        ? info.MedicalAppointmentProcedureSetSupplies.length > 0
        : false;

      let statusPhotography: StatusPhotography;

      if (info.StatusPhotography) {
        statusPhotography = this.statusPhotographies.filter(
          (x) => x.Id === info.StatusPhotography.Id
        )[0];
      }

      this.medicalAppointmentId = info.MedicalAppointmentId;

      this.medicalServiceCareForm.patchValue({
        MedicalAppointmentId: info.MedicalAppointmentId,
        IsInternation: info.IsInternation,
        MedicalAppointmentProcedureIds: info.MedicalAppointmentProcedureIds,
        CommentaryPreStudy:
          info.MedicalAppointmentCareResult.CommentaryPreStudy,
        ClinicaDataRecord: info.MedicalAppointmentCareResult.ClinicaDataRecord,
        IsEndAttention: false,
        PreviousStudiesAmount: info.PreviousStudiesAmount,
        PreviousStudiesDetails: info.PreviousStudiesDetails,
        PlatesDelivery:
          this.medicalServiceWizardService.medicalServiceSearchItem
            .PlatesDelivery,
        CdDelivery:
          this.medicalServiceWizardService.medicalServiceSearchItem.CdDelivery,
        PlatesAmount:
          this.medicalServiceWizardService.medicalServiceSearchItem
            .PlatesAmount,
        PreviousStudies:
          this.medicalServiceWizardService.medicalServiceSearchItem
            .PreviousStudies,
        ProcedureState:
          this.medicalServiceWizardService.medicalServiceSearchItem
            .ProcedureState,
        StatusPhotography: statusPhotography,
      });

      this.completed = true;
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Atención paciente"
      );
    } finally {
      this.loading = false;
    }
  }

  openPreviusStudiesShowDialog() {
    const medicalAppointmentId =
      this.medicalServiceCareForm.controls.MedicalAppointmentId.value;

    this.dialog.open(PreviousStudiesDigitizedShowDialogComponent, {
      width: "50%",
      data: medicalAppointmentId,
    });
  }

  uploadFile(event) {
    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      const reader = new FileReader();
      reader.readAsDataURL(element);
      this.uploading = true;
      reader.onload = (_event) => {
        const base64Url = <string>reader.result;
        const img = base64Url.split("base64,")[1];
        const medicalAppointmentId =
          this.medicalServiceCareForm.controls.MedicalAppointmentId.value;
        this.psdService
          .addPreviousStudiesDigitized(medicalAppointmentId, img)
          .then(() => (this.uploading = false))
          .catch((err) => {
            this.uploading = false;
            this.notificationToastService.error(
              JSON.stringify(err.error),
              "Atención paciente"
            );
          });
      };
    }
  }

  ngOnDestroy(): void {
    this.mobileScannService.unsubscribe();
  }
}
